import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ palette, spacing }) => ({
  questionsContainer: {
    position: "relative",
    overflow: "hidden",
  },
  greenCircle: {
    border: `40px solid ${palette.primary.main}`,
    borderRadius: "50%",
    width: "300px",
    height: "300px",
    position: "absolute",
    top: "10em",
    right: "10em",
    zIndex: -2,
  },
  blueCircle: {
    border: `40px solid ${palette.secondary.main}`,
    borderRadius: "50%",
    width: "360px",
    height: "360px",
    position: "absolute",
    bottom: "2em",
    right: "-10em",
    zIndex: -1,
  },
  content: {
    display: "grid",
    gridTemplateRows: "auto auto auto",
    gridTemplateColumns: "60%",
    gap: spacing(5),
    justifyItems: "center",
    margin: `${spacing(5)}px 0`,
  },

  contentMob: {
    marginLeft: "5%",
    marginTop: "5%",
  },

  title: {
    fontWeight: 800,
    fontSize: "52px",
    lineHeight: "63px",
    textTransform: "uppercase",
  },
  questions: {
    width: "90%",
  },
  eachQuestion: {
    fontWeight: 800,
    fontSize: "20px",
    lineHeight: "29px",
  },
  answer: {
    color: "#5E6162",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "29px",
  },
  icon: {
    fontSize: "2em",
  },
  message: {
    width: "90%",
    display: "grid",
    gridTemplateColumns: "50% 50%",
    placeItems: "center",
  },

  messageMob: { marginTop: "10%", marginBottom: "10%" },

  help: {
    color: "#5E6162",
    fontWeight: 800,
    fontSize: "30px",
    lineHeight: "44px",
  },

  helpMob: {
    color: "#5E6162",
    fontWeight: 800,
    fontSize: "33px",
    lineHeight: "44px",
    marginBottom: "10%",
  },
  accordionGap: {
    marginBottom: "15px!important",
  },
}));

export default useStyles;
